export const SM = "(max-width: 576px)"
export const MD = "(max-width: 768px)"
export const LG = "(max-width: 992px)"
export const XL = "(max-width: 1200px)"
